module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



//////////////////
// WEBPACK FOOTER
// /Users/Fuunnx/workspace/zygmund/~/core-js/library/modules/_is-object.js
// module id = ../../../node_modules/core-js/library/modules/_is-object.js
// module chunks = 0